
/**
 * 토픽 기본 정보
 */
export type TopicResponseBasicInfoAllOfTwo = {
  title: string;
};
